/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Image_InvalidInputs */

const vi_error_shop_image_invalid = /** @type {(inputs: Error_Shop_Image_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh không hợp lệ: hãy tải ảnh lên lại từ máy (chỉ nhận ảnh đã tải lên ERP).`)
};

/**

* @param {Error_Shop_Image_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_image_invalid = /** @type {((inputs?: Error_Shop_Image_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Image_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_image_invalid(inputs)
});